export enum NotificationModes {
  success = 'SUCCESS',
  warning = 'WARNING',
  error = 'ERROR',
}
